export default {"src":"__ASTRO_ASSET_IMAGE__C$w1VX9i__","width":143,"height":146,"format":"svg"}